var map = {
	"./artivle_bg.jpg": 1360,
	"./close_acrdin_ic.svg": 1361,
	"./dashboard_bg.jpg": 1362,
	"./faq_bg.jpg": 1363,
	"./homepage_bg.jpeg": 1364,
	"./metamask.png": 523,
	"./next_arrow.svg": 1365,
	"./open_acdn_ic.svg": 1366,
	"./opn_img.png": 1367,
	"./pool_page_bg.jpeg": 1368,
	"./prew_arrow.svg": 1369,
	"./roadmap_bg.jpg": 1370,
	"./roadmap_bg.png": 1371,
	"./staking_bg.jpg": 1372,
	"./swap_bg.jpg": 1373,
	"./tech_bg_img.png": 1374,
	"./tech_bg_img1.png": 1375,
	"./walletConnectIcon.svg": 307,
	"./x.svg": 1376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;